import * as appSelectors from './appSelectors.js';
import * as authSelectors from './authSelectors.js';
import * as crmAdwordsSelectors from './crmAdwordsSelectors.js';
import * as crmEmailSelectors from './crmEmailSelectors.js';
import * as crmFacebookAdsSelectors from './crmFacebookAdsSelectors.js';
import * as crmFacebookReportsSelectors from './crmFacebookReportsSelectors.js';
import * as crmInstagramReportsSelectors from './crmInstagramReportsSelectors.js';
import * as filterSelectors from './filterSelectors.js';
import * as leadSelectors from './leadSelectors.js';
import * as messageSelectors from './messageSelectors.js';
import * as pipelineSelectors from './pipelineSelectors.js';
import * as querySelectors from './querySelectors.js';
import * as reportingSelectors from './reportingSelectors.js';
import * as serviceProviderSelectors from './serviceProviderSelectors.js';
import * as todoSelectors from './todoSelectors.js';
import * as insightsSelectors from './insightsSelectors.js';

export const selectors = {
  ...querySelectors,
  ...serviceProviderSelectors,
  ...filterSelectors,
  ...todoSelectors,
  ...messageSelectors,
  ...authSelectors,
  ...appSelectors,
  ...reportingSelectors,
  ...leadSelectors,
  ...pipelineSelectors,
  ...crmFacebookReportsSelectors,
  ...crmInstagramReportsSelectors,
  ...crmEmailSelectors,
  ...crmAdwordsSelectors,
  ...crmFacebookAdsSelectors,
  ...insightsSelectors,
};

export default selectors;
